// Copyright © 2026 Neosocios - Seguimiento De Conversiones

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    initializeTracking();
  }, 2000);

  function initializeTracking() {
    const urlParams = getUrlParams();
    const cookies = getTrackingCookies();
    const updateToken = sessionStorage.getItem("tracking_updated");

    if (
      (hasValidParams(urlParams) || hasValidCookies(cookies)) &&
      updateToken !== "true"
    ) {
      updateCartWithTracking(urlParams, cookies);
    }
  }

  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      // Prioridad a parámetros Neosocios, fallback a UTMs tradicionales
      source: params.get("neose") || params.get("utm_source"),
      medium: params.get("neomm") || params.get("utm_medium"),
      campaign: params.get("neocn") || params.get("utm_campaign"),
      term: params.get("neotm") || params.get("utm_term"),
      content: params.get("neoct") || params.get("utm_content"),
    };
  }

  function getTrackingCookies() {
    return {
      fbp: getCookie("_fbp"),
      fbc: getCookie("_fbc"),
      ttp: getCookie("_ttp"),
      ttclid: getCookie("ttclid"),
      gclid: getGclidFromCookie(),
    };
  }

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : null;
  }

  function getGclidFromCookie() {
    const gclAw = getCookie("_gcl_aw");
    if (gclAw) {
      const parts = gclAw.split(".");
      return parts[parts.length - 1] || null;
    }
    return null;
  }

  function hasValidParams(params) {
    return Object.values(params).some(
      (value) => value !== null && value !== ""
    );
  }

  function hasValidCookies(cookies) {
    return Object.values(cookies).some(
      (value) => value !== null && value !== ""
    );
  }

  async function getCart() {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) throw new Error("Error obteniendo carrito");
      return await response.json();
    } catch (error) {
      console.error("Neosocios: Error al obtener carrito:", error);
      throw error;
    }
  }

  async function updateCartAttributes(attributes) {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributes }),
      });

      if (!response.ok)
        throw new Error("Error actualizando atributos del carrito");
      return await response.json();
    } catch (error) {
      console.error("Neosocios: Error al actualizar atributos:", error);
      throw error;
    }
  }

  function buildTrackingAttributes(urlParams, cookies, existingAttributes = {}) {
    // Atributos permitidos (whitelist) - preserva solo estos del carrito existente
    const allowedAttributes = [
      "Neosocios",
      "Source",
      "Medium",
      "Campaign",
      "Term",
      "Content",
      "fbp",
      "fbc",
      "ttp",
      "ttclid",
      "gclid",
    ];

    // Limpiar atributos existentes, manteniendo solo los permitidos
    const cleanedAttributes = {};
    allowedAttributes.forEach((attr) => {
      if (existingAttributes[attr]) {
        cleanedAttributes[attr] = existingAttributes[attr];
      }
    });

    // Agregar atributo de verificación de Neosocios SIEMPRE
    cleanedAttributes.Neosocios = "true";

    // Agregar parámetros UTM solo si existen
    if (urlParams.source) cleanedAttributes.Source = urlParams.source;
    if (urlParams.medium) cleanedAttributes.Medium = urlParams.medium;
    if (urlParams.campaign) cleanedAttributes.Campaign = urlParams.campaign;
    if (urlParams.term) cleanedAttributes.Term = urlParams.term;
    if (urlParams.content) cleanedAttributes.Content = urlParams.content;

    // Agregar cookies de tracking solo si existen
    if (cookies.fbp) cleanedAttributes.fbp = cookies.fbp;
    if (cookies.fbc) cleanedAttributes.fbc = cookies.fbc;
    if (cookies.ttp) cleanedAttributes.ttp = cookies.ttp;
    if (cookies.ttclid) cleanedAttributes.ttclid = cookies.ttclid;
    if (cookies.gclid) cleanedAttributes.gclid = cookies.gclid;

    return cleanedAttributes;
  }

  async function updateCartWithTracking(urlParams, cookies) {
    try {
      // Obtener carrito actual
      const cart = await getCart();
      const currentAttributes = cart.attributes || {};

      // Construir nuevos atributos (limpia y combina con nuevos datos)
      const updatedAttributes = buildTrackingAttributes(
        urlParams,
        cookies,
        currentAttributes
      );

      // Detectar si realmente hay cambios
      const hasChanges =
        JSON.stringify(currentAttributes) !== JSON.stringify(updatedAttributes);

      if (hasChanges) {
        await updateCartAttributes(updatedAttributes);

        // Marcar como actualizado en sessionStorage
        sessionStorage.setItem("tracking_updated", "true");

        console.log("Neosocios: Cart attributes updated successfully");
        console.log("Neosocios: Updated cart attributes:", updatedAttributes);
      } else {
        console.log("Neosocios: No changes detected in tracking attributes");
      }
    } catch (error) {
      console.error("Neosocios: Error en el proceso de tracking:", error);
    }
  }
});